/* eslint-disable @next/next/no-img-element */
import { useEffect, useRef, useState } from "react"
import { HoverSkew } from "../HoverSkew"
import { LargeHeading, Paragraph, Section } from "../misc"
import Hero from "public/marketing/templates.png"
import { ColorBlur } from "../ColorBlur"

export const Templates = ({
  text = `Start from scratch, or from a template`,
}: {
  text?: string
}) => {
  return (
    <Section className="text-center -mx-5">
      {/* <ColorBlur></ColorBlur> */}
      <div className="flex flex-col gap-1 text-center items-center pb-10 px-5">
        <LargeHeading>{text}</LargeHeading>
        <Paragraph className="!max-w-[700px] !text-opacity-70">{`200+ paywall templates to choose from, 100% free of charge. Edit everything from text and fonts to colors and images.`}</Paragraph>
      </div>
      <div
        className="w-full bg-brand-primary h-[62vw] md:h-[500px]"
        style={{
          background: `url(${Hero.src})`,
          backgroundSize: "cover",
          backgroundRepeat: "repeat-x",
          backgroundPosition: "left",
          animation: "slide 180s infinite linear",
        }}
      ></div>
    </Section>
  )
}
